import actions from './actions';
const initState = {
    bulkActivationFResponse: [],
    bulkActivationLoading: false,
    bulkActivationMessage: null,
    bulkActivationError: null,

    availableICCID: null,
    getAvailableICCIDLoading: false,
    getAvailableICCIDError: null,
    getAvailableICCIDMessage: null,

}

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.BULK_ACTIVATION:
            return {
                ...state,
                bulkActivationFResponse: [],
                bulkActivationLoading: true,
                bulkActivationMessage: null,
                bulkActivationError: null,
            };
        case actions.BULK_ACTIVATION_SUCCESS:
            return {
                ...state,
                bulkActivationLoading: false,
                bulkActivationMessage: action.payload.message,
                bulkActivationError: null,
            };
        case actions.BULK_ACTIVATION_FAILED:
            return {
                ...state,
                bulkActivationLoading: false,
                bulkActivationMessage: null,
                bulkActivationError: action.payload.error,
                bulkActivationFResponse: action.payload.data || [],

            };

        case actions.GET_AVAILABLE_ICCID:
            return {
                ...state,
                availableICCID: null,
                getAvailableICCIDLoading: true,
                getAvailableICCIDError: null,
                getAvailableICCIDMessage:null
            };
        case actions.GET_AVAILABLE_ICCID_SUCCESS:
            return {
                ...state,
                getAvailableICCIDLoading: false,
                getAvailableICCIDMessage:action.payload.message,
                availableICCID: action.payload.data,
                getAvailableICCIDError: null,
            };
        case actions.GET_AVAILABLE_ICCID_FAILED:
            return {
                ...state,
                getAvailableICCIDLoading: false,
                getAvailableICCIDError: action.payload.error,
                getAvailableICCIDMessage:null

            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                bulkActivationFResponse: [],
                bulkActivationMessage: null,
                bulkActivationError: null,
            };



        default:
            return state;
    }
}